// export class BlanketOrderSummaryVM {
//  product: string
//  pricingUOM: string
//  pricingPerUnitPricingUOM: number
//  package: string
//  orderUOM: string
//  pricePerUnitOrderUOM: number
// }

export class BlanketOrderSummaryVM {
  emailAddress: string;
  primaryPhoneNumber: string;
  webOrderNumber: string;
  splitId: number;
  placedBy: string;
  placedByName: string;
  createdOn?: Date;
  accountAddress1: string;
  accountAddress2: string;
  accountNumber: string;
  accountName: string;
  accountCity: string;
  accountState: string;
  accountZipCode: string;
  asc: string;
  orderStatus: string;
  // productDetail: BlanketOrderSummaryItemList[]
  product: string;
  pricingUOM: string;
  pricingPerUnitPricingUOM: number;
  package: string;
  orderUOM: string;
  pricePerUnitOrderUOM: number;
  blanketOrderId: number;
  headerText: string;
  instructionType: string;
  customerPickUp: string;
  custPONumber: string;
  jdeorderNumber: string;
  desiredDeliveryDate?: Date;
  splitDetails: BlanketOrderSplitDetails[];
  ascDetail: BlanketAscDetail;
  dsmDetail: BlanketDSMDetail;
  deliverToDetail: BlanketDeliverToDetail;
  soldToDetail: BlanketSoldToDetail;
}
export class BlanketAscDetail {
  ascName: string;
  ascAddress1: string;
  ascAddress2: string;
  city: string;
  state: string;
  zipCode: string;
  primaryPhone: string;
  emailAddress: string;
}
export class BlanketDSMDetail {
  dsmAccountName: string;
  dsmAddress1: string;
  city: string;
  state: string;
  zipCode: string;
  primaryPhone: string;
  emailAddress: string;
}

export class BlanketDeliverToDetail {
  accountNo: string;
  accountName: string;
  address1: string;
  city: string;
  state: string;
  zipCode: string;
}

export class BlanketSoldToDetail {
  accountNo: string;
  accountName: string;
  address1: string;
  address2: string;
  city: string;
  state: string;
  zipCode: string;
}

export class BlanketOrderSummaryItemList {
  itemId: number;
  itemNumber: string;
  itemDescription: string;
  itemVendorName: string;

  packageSize: string;
  gtin: string;
  actveIngredient: string;  // Need to be send as comma seperated string
  productSegment: string;
  productLine: string;
  palletQuantity?: number;
  programName: string;
  bulkPackaged: string;
  vendedProprietary: string;
  xrefCheckBK: string;
  itemFlashMsg: string;
  restrictedUse: string;
  returnable: string;
  uom: string;
  price?: number;
  pricePerUnit?: number;
  priceCurrency: string;
  pricingUnitOfMeasure: string;
  pricingPackageSize: string;
  isFavorite: boolean;
  desiredDelDate?: Date;
  orderUOM: string;
  webStandardUOM: string;
  webStandardOrderUOM: string;
  pricingUnitConvFactor?: number;
  orderConvFactor?: number;
  productName: string;
  vendorName: string;
  pricingUOM: string;
  pricePerOrderUnit: number;
  originalOrderQuantity: number;
  totalPrice: number;
  quantityRemaining: number;
  quantitycanceled: number;
}

export class BlanketOrderSplitDetails {
  splitId: number;
  orderStatus: string;
  productDetail: BlanketOrderSummaryItemList[];
}
